import { useEffect, useState } from "react";

import { hasStoredAuthSession, loadSupabase, whenIdle } from "@/lib/supabase-lazy";

/** True för inloggade konton som har någon behörighet i administrationen. */
export function useIsAdmin(): boolean {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!hasStoredAuthSession()) return;
    let active = true;
    let unsubscribe: (() => void) | undefined;

    const cancelIdle = whenIdle(() => {
      void (async () => {
        const supabase = await loadSupabase();
        if (!active) return;

        async function check() {
          const { data } = await supabase.auth.getUser();
          if (!data.user) {
            if (active) setIsAdmin(false);
            return;
          }
          const [{ data: roles }, { data: pageAccess }] = await Promise.all([
            supabase
              .from("user_roles")
              .select("role")
              .eq("user_id", data.user.id)
              .in("role", ["admin", "staff", "editor", "recruiter", "reviewer"])
              .limit(1),
            supabase.from("admin_page_access").select("path").eq("user_id", data.user.id).limit(1),
          ]);
          if (active) setIsAdmin((roles ?? []).length > 0 || (pageAccess ?? []).length > 0);
        }

        void check();
        const { data: sub } = supabase.auth.onAuthStateChange((event) => {
          if (event === "SIGNED_IN" || event === "SIGNED_OUT") void check();
        });
        unsubscribe = () => sub.subscription.unsubscribe();
      })();
    });

    return () => {
      active = false;
      cancelIdle();
      unsubscribe?.();
    };
  }, []);

  return isAdmin;
}
